// Chargement unique du script YouTube IFrame API, partagé par tous les composants vidéo.
let ytApiPromise = null;

export function loadYouTubeApi() {
  if (window.YT && window.YT.Player) return Promise.resolve();
  if (ytApiPromise) return ytApiPromise;
  ytApiPromise = new Promise((resolve) => {
    const prev = window.onYouTubeIframeAPIReady;
    window.onYouTubeIframeAPIReady = () => {
      if (typeof prev === "function") { try { prev(); } catch (e) {} }
      resolve();
    };
    // Filet : si le script est bloqué (extension, réseau), on résout quand même pour
    // que les composants ne restent pas indéfiniment en attente.
    setTimeout(resolve, 6000);
    if (!document.querySelector('script[src="https://www.youtube.com/iframe_api"]')) {
      const tag = document.createElement("script");
      tag.src = "https://www.youtube.com/iframe_api";
      document.body.appendChild(tag);
    }
  });
  return ytApiPromise;
}
